export const widgetUiVersion = 'dev';
